import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import SetPasswordPage from '../pages/SetPasswordPage';

export function ProtectedRoute({ children, adminOnly = false }) {
  const { user, loading, markPasswordChanged } = useAuth();

  if (loading) {
    return (
      <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '100vh', color: 'var(--gold)' }}>
        🎄 Cargando...
      </div>
    );
  }

  if (!user) return <Navigate to="/login" replace />;
  if (user.must_change_password) return <SetPasswordPage onDone={markPasswordChanged} />;
  if (adminOnly && !user.is_admin) return <Navigate to="/home" replace />;

  return children;
}
